import classNames from 'classnames';
import React, { CSSProperties } from 'react';

export type TransactionListData = {
  date: string;
  type: 'credit' | 'debit';
  amount: string;
  rawAmount: number;
  balanceAmount?: string;
  item: number | string;
  body: string;
};

type TransactionListProps = {
  listData: TransactionListData[];
  containerClassName?: string;
  containerStyle?: CSSProperties;
};

const TransactionList = ({
  listData,
  containerClassName = '',
  containerStyle = {}
}: TransactionListProps) => {
  return (
    <ul
      className={classNames(containerClassName, 'flex flex-col')}
      style={containerStyle}
    >
      {listData.map(({ item, type, date, body, amount, balanceAmount }) => {
        return (
          <li className={'mx-4 flex items-start py-4'} key={item}>
            <span
              className={classNames(
                'w-4 h-4 rounded mt-2 flex-shrink-0',
                type === 'credit' ? 'bg-green-600' : 'bg-red-600'
              )}
            />
            <span className="font-body text-gray-800 px-4 flex flex-col flex-1">
              <span className="text-xs">{body}</span>
              <span className="text-xs text-gray-600">{date}</span>
            </span>
            <span className="font-body text-gray-800 flex flex-col">
              <span className={'text-sm'}>{amount}</span>
              {balanceAmount && (
                <span className="text-xs text-gray-600">{balanceAmount}</span>
              )}
            </span>
          </li>
        );
      })}
    </ul>
  );
};

export default TransactionList;
